import React from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram, Building2, ArrowUpRight } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Reveal } from "@/components/Reveal";
import { ContactForm } from "@/components/ContactForm";
import { CONTACT } from "@/content";

export default function Contact() {
  return (
    <Layout page="contact">
      <section className="relative pt-40 pb-14 overflow-hidden">
        <div className="absolute inset-0 mesh-top" />
        <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
          <span className="label">Contact</span>
          <h1 className="font-display font-black text-white tracking-tighter mt-4 leading-[0.95]" style={{ fontSize: "clamp(3rem, 10vw, 7.5rem)" }}>Say hello</h1>
          <p className="text-ice/80 text-lg max-w-2xl mt-6 leading-relaxed">{CONTACT.intro}</p>
        </div>
      </section>

      <section className="relative py-10 pb-28">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-2 gap-10">
          <Reveal><ContactForm /></Reveal>

          <Reveal delay={0.1}>
            <div className="space-y-6">
              <div className="rounded-3xl glass p-8">
                <p className="label mb-5">Direct contact</p>
                <a href={`mailto:${CONTACT.email}`} data-testid="contact-direct-email" className="flex items-center gap-3 text-ice hover:text-cyan transition-colors mb-4">
                  <Mail size={18} className="text-cyan" /> {CONTACT.email}
                </a>
                <a href={CONTACT.instagramUrl} target="_blank" rel="noreferrer" data-testid="contact-instagram" className="flex items-center gap-3 text-ice hover:text-cyan transition-colors">
                  <Instagram size={18} className="text-cyan" /> {CONTACT.instagram} <ArrowUpRight size={14} />
                </a>
              </div>

              <div data-testid="studios-section" className="rounded-3xl border border-electric/25 bg-electric/5 p-8">
                <div className="flex items-center gap-3 mb-4">
                  <Building2 size={20} className="text-cyan" />
                  <h3 className="font-display text-xl font-bold text-white">For studios & gyms</h3>
                </div>
                <p className="text-ice/75 leading-relaxed">{CONTACT.studios}</p>
              </div>

              <Link to="/book" data-testid="contact-book-link" className="block rounded-3xl border border-white/10 bg-ink-800 p-8 hover:border-cyan/40 transition-colors group">
                <p className="text-ice/80">Ready when you are.</p>
                <span className="inline-flex items-center gap-2 text-cyan mt-2 font-display text-xl font-bold">Browse Classes or Book <ArrowUpRight className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" size={20} /></span>
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}
